// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InfoBulle_info__2_-H8 {\n  cursor: pointer;\n  color: #007bff;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Wrapper/InfoBulle.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".info {\n  cursor: pointer;\n  color: #007bff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": "InfoBulle_info__2_-H8"
};
export default ___CSS_LOADER_EXPORT___;
